import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import * as profileActions from '../actions/profileActions';
import * as policyActions from '../actions/policyActions';

import Dashboard from './Dashboard';
import { Container } from 'semantic-ui-react';
import { scroller as scroll, animateScroll } from 'react-scroll';
import { AgencySection, PolicySection, ClaimSection } from './sections';
import PaymentSection from './sections/PaymentSection';

/*import McxSurvey from '../components/McxSurvey';*/
import QualtricsSurvey from '../components/QualtricsSurvey';
import { profileSelector } from '../selectors';
import AutoIdCardSection from './sections/AutoIdCardSection';

class HomePage extends Component {
	constructor(props) {
		super(props);
		this.linkClick = this.linkClick.bind(this);

		this.state = {};
		this.onDeepLinkComplete = this.onDeepLinkComplete.bind(this);
		this.deepLinkIfNecessary = this.deepLinkIfNecessary.bind(this);
	}

	async componentDidMount() {
		const { actions } = this.props;
		const profileResult = await actions.getProfile();

		if (profileResult.response.policies.length > 0) {
			actions.getPolicies(profileResult.response.policies).then(() => {
				const path = this.props.location.pathname;
				this.deepLinkIfNecessary(path);
			});
		}
	}

	linkClick(e) {
		e.preventDefault();
		const { pathname, search, hash } = e.target.href ? e.target : e.target.closest('a');
		const url = pathname + search + hash;
		this.props.actions.push(url);
		this.deepLinkIfNecessary(pathname);
	}

	deepLinkIfNecessary(path) {
		const matchingIndex = path.search('^/([a-zA-Z]{3}[0-9]{7})/.+');
		if (matchingIndex > -1) {
			var regex = new RegExp('^/([a-zA-Z]{3}[0-9]{7})/(.+)');
			var matches = path.match(regex);
			this.setState({
				deepLink: {
					policyNumber: matches[1],
					action: matches[2],
				},
			});

			if (matches[2] === 'documents') {
				scroll.scrollTo('policies', {
					duration: 500,
					delay: 100,
					smooth: true,
					offset: -100,
				});
			}

			window.history.replaceState({}, null, '/');
		} else {
			const element = path.replace('/', '');

			if (element.length && ['payments', 'claims', 'policies', 'agency', 'autoidcards'].includes(element)) {
				return scroll.scrollTo(element, {
					duration: 500,
					delay: 100,
					smooth: true,
					offset: -100,
				});
			}

			if (element === 'paynow') {
				this.setState({
					deepLink: {
						policyNumber: null,
						action: 'paynow',
					},
				});
			}

			if (element === 'help') {
				this.setState({
					deepLink: {
						policyNumber: null,
						action: 'help',
					},
				});
				this.props.actions.push('/');
			}

			if (element.length === 0) {
				return animateScroll.scrollToTop({
					duration: 500,
					delay: 100,
					smooth: true,
				});
			}
		}
	}

	onDeepLinkComplete() {
		this.setState({ deepLink: null });
	}

	render() {
		const { profile, app } = this.props;
		const { deepLink } = this.state;

		return (
			<div>
				<Container>
					<Dashboard deepLink={deepLink && deepLink.action === 'help' ? deepLink : null} onDeepLinkComplete={this.onDeepLinkComplete} onClick={this.linkClick} mobileShow={this.props.location.pathname === '/'} />
				</Container>
				<PaymentSection deepLink={deepLink && deepLink.action === 'paynow' ? deepLink : null} onDeepLinkComplete={this.onDeepLinkComplete} mobileShow={this.props.location.pathname === '/payments' || (deepLink && deepLink.action === 'paynow')} />
				<PolicySection deepLink={deepLink && deepLink.action === 'documents' ? deepLink : null} onDeepLinkComplete={this.onDeepLinkComplete} mobileShow={this.props.location.pathname === '/policies' || (deepLink && deepLink.action === 'documents')} />
				<AutoIdCardSection mobileShow={this.props.location.pathname === '/autoidcards'} onClick={this.linkClick} />
				<ClaimSection mobileShow={this.props.location.pathname === '/claims'} />
				<AgencySection mobileShow={this.props.location.pathname === '/agency'} />
				{/* <McxSurvey mobileShow={this.props.location.pathname === '/McxSurvey'}/> */}
				{/*{profile && profile.loaded && this.props.location.pathname === '/' && <McxSurvey email={profile.email.toLowerCase()} />}*/}
				{profile && profile.loaded && this.props.location.pathname === '/' && <QualtricsSurvey email={profile.email.toLowerCase()} />}				
			</div>
		);
	}
}

HomePage.propTypes = {
	actions: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
	return {
		...state,
		profile: profileSelector(state),
	};
};

const mapDispatchToProps = (dispatch) => ({
	actions: {
		...bindActionCreators({ push }, dispatch),
		...bindActionCreators(profileActions, dispatch),
		...bindActionCreators(policyActions, dispatch),
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
